export const homeRoutesURLs = {
  mainPagePath: 'main/*',
  loginPagePath: '/',
  adminPagePath: 'admin/*',
  terminalPagePath: 'terminal',
  queuePagePath: 'queue',
  ratingPagePath: 'rate'
};

export const mainRoutesURLs = {
  agent1PagePath: 'agent1'
};

export const adminRoutesURLs = {
  branches: 'branches',
  sectionServices: 'section-services',
  workplaces: 'workplaces',
  employers: 'employers',
  audit: 'audit',
  analyticsAndReports: {
    analyticsAndReportsBase: 'analytics-and-reports',
    currentServicesStatus: 'current-services-status',
    services: 'services',
    employersReports: 'employerrs-reports',
    visitors: 'visitors',
    qualityReport: 'quality-report'
  },
  advertising: 'advertising',
  userArea: 'user-area',
  terminalAppearance: 'terminal-appearance',
  tabloSettings: 'tablo-settings',
  ratingSettings: 'rating-settings'
};

export function buildRatingPagePath(params: {
  branch: number;
  queue: string;
  cabinet: number | null;
  window: number | null;
}) {
  const formatNum = (v: number | null) => (v !== null ? String(v) : '-');
  const search = new URLSearchParams({
    branch: String(params.branch),
    queue: params.queue,
    cabinet: formatNum(params.cabinet),
    window: formatNum(params.window)
  });
  return `/${homeRoutesURLs.ratingPagePath}?${search.toString()}`;
}

export function buildAdminPath(subPath: string) {
  const baseAdminPath = homeRoutesURLs.adminPagePath.replace('/*', '');
  return `/${baseAdminPath}/${subPath}`;
}
